import { createApp } from 'vue'
import $ from 'jquery'
import App from './App.vue'
import router from './router'
import store from './store'

// ElementPlus
import ElementPlus from 'element-plus'
import { i18n } from '@/i18n'
import "./assets/css/child/element-variables.scss"
import * as ElementPlusIconsVue from "@element-plus/icons-vue"

// PrimeVue (TreeTable)
import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

// Ag-Grid
import LocalizedAgGrid from "@/components/AgGrid/LocalizedAgGrid.vue";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

// 引入天爱二维码校验插件
import "@/assets/plugins/captcha/tac.css"
import "@/assets/plugins/captcha/tac.min.js"

// 引入自定义样式
import "@/assets/css/index.scss"
import "@/assets/css/fontStyle.scss"

// 引入自定义工具类
import * as validateUtils from "@/utils/validateUtils"
import AppIcon from '@/components/AppIcon.vue'
import { installInputNumberSelectOnFocus } from '@/utils/inputNumberFocus.mjs'
import { installPageNavigationRuntime } from '@/utils/pageNavigationRuntime.mjs'

// zTree 依赖浏览器全局 jQuery
window.$ = $
window.jQuery = $


const app = createApp(App);
app.use(store);
app.use(router);
app.use(ElementPlus)
app.use(i18n)
app.use(PrimeVue)
installPageNavigationRuntime(app)

app.config.globalProperties.$validateUtils=validateUtils;

app.component('AppIcon', AppIcon)

// 注册 所有icon
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
// 注册 ag-grid
app.component("AgGridVue", LocalizedAgGrid);

// 数字输入框聚焦时全选当前值，便于直接覆盖输入。
installInputNumberSelectOnFocus()

// 全局屏蔽浏览器原生右键菜单，保留事件传播以兼容组件自定义右键行为。
document.addEventListener('contextmenu', (event) => {
    event.preventDefault()
}, { capture: true })

// 捕获错误，但不弹窗
app.config.errorHandler = (err, vm, info) => {
    console.error("[Vue Error]", err, info)
}

// 挂载应用
app.mount("#app");
